import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const proyectoFavoritoStateSlice = createSlice({
	name: 'proyectoFavoritoState',
	initialState,
	reducers: {
		setProyectoFavoritoState: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		}
	}
});

export const { setProyectoFavoritoState } = proyectoFavoritoStateSlice.actions;

export default proyectoFavoritoStateSlice.reducer;
